import { ThemeService } from '../../_core/services/theme.service';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { Match } from '../../_shared/models/match.model';
import { MatchService } from '../../_core/services/match.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Tie } from '../../_shared/models/tie.model';
import { ScoreFormat } from '../../_shared/models/score-format.model';
import { IntParticipantComponent } from './int-participant/int-participant.component';
import { IntStatusComponent } from './int-status/int-status.component';
import { IntPointComponent } from './int-point/int-point.component';
import { IntGameComponent } from './int-game/int-game.component';
import { ScoreboardService } from '../../scoreboard/scoreboard.service';
import { Socket } from 'ngx-socket-io';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-int-body',
  templateUrl: './int-body.component.html',
  styleUrls: ['./int-body.component.scss'],
  standalone: true,
  imports: [
    IntParticipantComponent,
    IntStatusComponent,
    IntPointComponent,
    IntGameComponent,
    CommonModule,
  ],
})
export class IntBodyComponent implements OnInit, OnChanges {
  private scoreboardService = inject(ScoreboardService);
  public themeService = inject(ThemeService);
  matchService = inject(MatchService);
  private readonly destroy$: Subject<void> = new Subject();

  @Input({ required: true }) match: Match;
  @Input({ required: true }) tie: Tie;
  @Input({ required: false }) summaryView: boolean;
  @Output() addPointOrGame = new EventEmitter<number>();

  isTracker: boolean;
  teamNameSide1: string;
  teamNameSide2: string;
  side1Color: string;
  side2Color: string;
  scoreFormat: ScoreFormat;
  teamLogoSide1: string;
  teamLogoSide2: string;
  teamProfileImageSide1: string;
  teamProfileImageSide2: string;
  pointScoreSide1: string;
  pointScoreSide2: string;
  totalSetScoreSide1: number;
  totalSetScoreSide2: number;

  constructor(private socket: Socket,){}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tie']) {
      this.tie = changes['tie'].currentValue;
      if (this.tie) {
        this.getTeamColors();
        this.getTeamLogo();
        this.getTeamProfileImage();
      }
    }
  }

  private getTeamLogo() {
    if (this.tie?.sides[0]?.team) {
      this.teamLogoSide1 = this.tie?.sides[0]?.team?.logo ?? '';
    }

    if (this.tie?.sides[1]?.team) {
      this.teamNameSide2 = this.tie?.sides[1]?.team?.logo ?? '';
    }

    return null;
  }

  private getTeamProfileImage() {
    if (this.tie?.sides[0]?.team) {
      this.teamProfileImageSide1 =
        this.tie?.sides[0]?.team?.profile_image ?? '';
    }

    if (this.tie?.sides[1]?.team) {
      this.teamProfileImageSide2 =
        this.tie?.sides[1]?.team?.profile_image ?? '';
    }

    return null;
  }

  public getTeamColors() {
    if (this.tie) {
      if (this.tie?.sides[0]?.team) {
        this.side1Color = this.scoreboardService.getColor(1, this.tie);
      }

      if (this.tie?.sides[1]?.team) {
        this.side2Color = this.scoreboardService.getColor(2, this.tie);
      }
    } else {
      const isDarkMode = this.themeService.isDarkMode;
      this.side1Color = isDarkMode ? '#8bc34a' : '#009688';
      this.side2Color = isDarkMode ? '#8bc34a' : '#009688';
    }
  }

  async ionViewWillEnter() {
    this.socketSubscriptions();
  }

  private socketSubscriptions() {
    this.getTieStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe((status: any) => {
        this.tie.winningSide = status.winningSide;
        this.tie.matchStatus = status.matchStatus;
        this.tie.score = status.score;
      });
  }

  private getTieStatus() {
    const observable = new Observable((observer) => {
      this.socket.on('tie-status-updated', (data) => observer.next(data));
    });
    return observable;
  }
}
